import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { FirmwarePaginationListenerEffect } from '../effects/firmware-pagination-listener.effect';
import {
  addPagination,
  filterFirmwaresByBrand,
  filterFirmwaresByEcus,
  filterFirmwaresByModel,
  filterFirmwaresByName,
  filterFirmwaresByPlatform,
  resetPagination,
} from '../store/slices/firmware.slice';

export const firmwarePaginationListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeFirmwarePaginationListener: UnsubscribeListener =
  firmwarePaginationListener.startListening({
    matcher: isAnyOf(
      filterFirmwaresByName,
      filterFirmwaresByPlatform,
      filterFirmwaresByEcus,
      filterFirmwaresByModel,
      filterFirmwaresByBrand,
      addPagination,
      resetPagination
    ),
    effect: FirmwarePaginationListenerEffect,
  });
